export const reducerTypes = {
    GET_ALL_CONTACTUS: "reducer/GET_ALL_CONTACTUS",
    GET_MORE_CONTACTUS: "reducer/GET_MORE_CONTACTUS",
    SET_PAGE_INFO: "reducer/SET_PAGE_INFO",
    SET_PAGE_INDEX: "reducer/SET_PAGE_INDEX",
    SET_PAGE_SIZE: "reducer/SET_PAGE_SIZE",
    GET_CONTACTUS: "reducer/GET_CONTACTUS",
    IS_LOADING: "reducer/LOADING_TRUE",
  };
  
  export const sagaTypes = {
    GET_ALL_CONTACTUS: "saga/GET_ALL_CONTACTUS",
    GET_MORE_CONTACTUS: "saga/GET_MORE_CONTACTUS",
    GET_CONTACTUS: "saga/GET_CONTACTUS",
  };
  